import { useContext } from 'react';
import { TerritoryContext } from 'softcat:contexts/territory.tsx';

export const useTerritory = () => {
    const territoryContext = useContext(TerritoryContext);

    if (!territoryContext) {
        throw new Error('TerritoryContext has to be used within <TerritoryProvider>');
    }

    return territoryContext;
};
